import React, { useState, useEffect } from 'react';
import { func } from 'prop-types';
import cookies from 'react-cookies';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box, Button as MuiButton } from '@material-ui/core';
import { Typography, useError } from '@avon/component-library';
import { getOptOutConfig } from '../../utils/api/endpoints';

import img1 from '../../styles/assets/learn_more_1.png';
import img2 from '../../styles/assets/learn_more_2.png';
import img3 from '../../styles/assets/learn_more_3.png';
import closeSvg from '../../styles/assets/close.svg';

import { isMobile } from '../../utils/getDeviceType';

const useStyles = makeStyles(theme => ({
  topbar: {
    zIndex: 102,
    top: 0,
    position: 'sticky',
  },
  toolbar: {
    display: 'flex',
    zIndex: 102,
    width: '100%',
    textAlign: 'justify',
    textAlignLast: 'justify',
    paddingTop: theme.spacing(2.5),
    paddingLeft: styleProps => (styleProps.language === 'ar' ? theme.spacing(3) : theme.spacing(1)),
    paddingRight: styleProps => (styleProps.language === 'ar' ? theme.spacing(1) : theme.spacing(3)),
    backgroundColor: theme.palette.colors.white,
    '& span': {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontSize: 16,
    },
  },
  gridButton1: {
    minHeight: theme.spacing(3),
    width: 'auto',
    paddingTop: 0,
    paddingBottom: 0,
    wordBreak: 'break-word',
    color: theme.palette.colors.textDark,
  },
  gridButton2: {
    minHeight: theme.spacing(3),
    width: 'auto',
    paddingTop: 0,
    paddingBottom: 0,
    wordBreak: 'break-word',
    color: theme.palette.colors.corePink,
    '&:hover': {
      backgroundColor: 'rgba(24, 24, 24, 0.08)',
    },
  },
}));

const slideDot = color => (
  <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3.5" cy="3" r="3" fill={color} />
  </svg>
);

const LearnMore = ({ callApi, redirectTo }) => {
  const theme = useTheme();
  const cls = useStyles();

  const { setError, cleanToastBanner } = useError();
  const [step, setStep] = useState(0);
  const [optOutConfig, setOptOutConfig] = useState();
  const language = cookies.load('langCd');

  // get the opt out config
  useEffect(() => {
    const getConfig = async () => {
      try {
        await callApi(getOptOutConfig()).then((res) => {
          setOptOutConfig(res.jsonObject);
        });

        cleanToastBanner();
        return true;
      } catch (e) {
        setError(e.error);
        return false;
      }
    };

    getConfig();
  }, []);

  useEffect(() => { }, [step]);

  const {
    title, page1, page2, page3, next = 'NEXT', close = 'CLOSE',
  } = optOutConfig || {};

  const pages = [page1, page2, page3];
  const imgs = [img1, img2, img3];

  return optOutConfig ? (
    <Box>
      <Box id="header" className={cls.topbar}>
        <Box
          data-testid="toolbar"
          id="admin-pma-toolbar"
          component="div"
          className={cls.toolbar}
        >
          <MuiButton
            color="secondary"
            variant="contained"
            className={cls.gridButton1}
            id="pma-toolbar-left-button"
          />
          <Typography
            variant="h4"
            style={{
              alignSelf: isMobile() ? 'center' : 'unset',
              flexGrow: 1,
              fontSize: '16px',
              margin: isMobile() ? 'unset' : 24,
              // eslint-disable-next-line
              textAlignLast: isMobile() ? 'center' : language === 'ar' ? 'right' :'left',
            }}
          >
            {title}
          </Typography>
          <MuiButton
            className={cls.gridButton2}
            id="back-home-button-pma"
            onClick={() => redirectTo({
              type: 'lma', subType: 'optLeads', hasFooter: false, params: null,
            })}
          >
            <img alt="close" src={closeSvg} />
            {/* {toolBarObject.close} */}
          </MuiButton>
        </Box>
      </Box>
      <Box id="body" textAlign="center" mt={isMobile() ? '48px' : '92px'}>
        <img alt={`learn${step}`} src={imgs[step]} />
        <Typography style={{ margin: isMobile() ? '48px 20px' : '48px calc((100% - 468px)/2) 42px' }}>{pages[step]}</Typography>
      </Box>
      <Box id="dots" textAlign="center">
        <Box style={{ display: 'inline-block', margin: '0 5px' }}>
          {slideDot(step === 0 ? theme.palette.colors.corePink : theme.palette.colors.greyText)}
        </Box>
        <Box style={{ display: 'inline-block', margin: '0 5px' }}>
          {slideDot(step === 1 ? theme.palette.colors.corePink : theme.palette.colors.greyText)}
        </Box>
        <Box style={{ display: 'inline-block', margin: '0 5px' }}>
          {slideDot(step === 2 ? theme.palette.colors.corePink : theme.palette.colors.greyText)}
        </Box>
      </Box>
      <Box textAlign="center">
        <MuiButton
          style={{
            background: theme.palette.colors.corePink, color: '#FFFFFF', margin: '26px 28px 46px', width: isMobile() ? 'calc(100% - 56px)' : 320,
          }}
          onClick={() => (step < 2 ? setStep(step + 1) : redirectTo({
            type: 'lma', subType: 'optLeads', hasFooter: false, params: null,
          }))
          }
        >
          {step < 2 ? next : close}
        </MuiButton>
      </Box>
    </Box>
  ) : null;
};

LearnMore.propTypes = {
  callApi: func.isRequired,
  redirectTo: func.isRequired,
};

export default LearnMore;
